// src/seedTasks.js
import pb from './pb';

const CHORE_SEED = [
  { name: 'Vacuum cottage',        freq: 'weekly',      defaultOwner: 'HB' },
  { name: 'Clean wooden floors',   freq: 'weekly',      defaultOwner: 'DB' },
  { name: 'Washing & folding',     freq: 'weekly',      defaultOwner: 'none' },
  { name: 'Bathroom',              freq: 'weekly',      defaultOwner: 'LB' },
  { name: 'Toilet',                freq: 'weekly',      defaultOwner: 'LB' },
  { name: 'Kitchen',               freq: 'weekly',      defaultOwner: 'HB' },
  { name: 'Water garden/s',        freq: 'daily',       defaultOwner: 'DB' },
  { name: 'Change bed LB',         freq: 'weekly',      defaultOwner: 'LB' },
  { name: 'Change bed HB',         freq: 'weekly',      defaultOwner: 'HB' },
  { name: 'Change bed M&D',        freq: 'weekly',      defaultOwner: 'NM' },
  { name: 'Dusting',               freq: 'fortnightly', defaultOwner: 'HB' },
  { name: 'Clean tiled floors',    freq: 'fortnightly', defaultOwner: 'DB' },
  { name: 'Clean out fridge',      freq: 'fortnightly', defaultOwner: 'NM' },
  { name: 'Clean mirrors',         freq: 'monthly',     defaultOwner: 'HB' },
  { name: 'Clean windows',         freq: 'quarterly',   defaultOwner: 'HB' },
  { name: 'Clear gutters',         freq: 'quarterly',   defaultOwner: 'LB' },
  { name: 'Wipe walls',            freq: 'quarterly',   defaultOwner: 'HB' },
  { name: 'Clean oven',            freq: 'quarterly',   defaultOwner: 'NM' },
];

// One-time, idempotent seed
export async function seedTasksIfNeeded() {
  try {
    // Get existing task names to avoid duplicates
    const existing = await pb.collection('tasks').getFullList({ fields: 'id,name' });
    const have = new Set(existing.map(r => (r.name || '').trim().toLowerCase()));

    const toCreate = CHORE_SEED.filter(t => !have.has(t.name.toLowerCase()));

    for (const t of toCreate) {
      const payload = {
        name: t.name,
        freq: t.freq,
        defaultOwner: t.defaultOwner,
      };
      if (t.freq === 'fortnightly') payload.phase = 0; // only send when needed

      await pb.collection('tasks').create(payload);
    }

    console.log(`Chore seed complete. Inserted ${toCreate.length} new tasks.`);
    return toCreate.length;
  } catch (err) {
    console.error('Chore seed failed:', err);
    throw err;
  }
}